export enum DashboardMode {
  SETUP = "SETUP",
  TODAY = "TODAY",
}
